import i18n from '../plugins/i18n';

export const translateConsumptionDevicesStatus = (order_status) => {
  switch (order_status) {
    case 'ORDER_CREATED':
      return [i18n.t('consumption_devices.ORDER_CREATED'), '#D79BB8'];
    case 'CRITICAL_ORDER_CREATED':
      return [i18n.t('consumption_devices.CRITICAL_ORDER_CREATED'), '#D79BB8'];
    case 'ORDER_PROCESSING':
      return [i18n.t('consumption_devices.ORDER_PROCESSING'), '#CF8AA9'];
    case 'ORDER_INSPECTION_READY':
      return [i18n.t('consumption_devices.ORDER_INSPECTION_READY'), '#B7567B'];
    case 'ORDER_IN_INSPECTION':
      return [i18n.t('consumption_devices.ORDER_IN_INSPECTION'), '#AE436C'];
    case 'ORDER_CONFIRMED':
      return [i18n.t('consumption_devices.ORDER_CONFIRMED'), '#9B0040'];
    case 'ORDER_TRANSMITTED':
      return [i18n.t('consumption_devices.ORDER_TRANSMITTED'), '#9B0040'];
    case 'ORDER_CANCELLED':
      return [i18n.t('order_statuses.ORDER_CANCELLED'), '#ffffff'];
    case 'ORDER_DECLINED':
      return [i18n.t('order_statuses.ORDER_DECLINED'), '#525252'];
    default:
      return [];
  }
};
